import { render, staticRenderFns } from "./userFrame.vue?vue&type=template&id=673e5ce1&scoped=true"
import script from "./userFrame.vue?vue&type=script&lang=js"
export * from "./userFrame.vue?vue&type=script&lang=js"
import style0 from "./userFrame.vue?vue&type=style&index=0&id=673e5ce1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673e5ce1",
  null
  
)

export default component.exports